function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWaterFilterSensor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Ellipse 546",
    transform: "translate(7 7)",
    style: {
      stroke: "#f5f5f5",
      strokeWidth: 6
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    style: {
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 15,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Pfad 2745",
    d: "M14.63 9.712a.7.7 0 0 1-.495-.2 3.091 3.091 0 0 0-4.27 0 .7.7 0 0 1-.99-.99 4.418 4.418 0 0 1 6.25 0 .7.7 0 0 1-.495 1.195M16.6 7.74a.7.7 0 0 1-.495-.2 5.815 5.815 0 0 0-8.215 0 .7.7 0 1 1-.99-.99 7.219 7.219 0 0 1 10.2 0 .7.7 0 0 1-.5 1.195m1.973-1.973a.7.7 0 0 1-.5-.2 8.605 8.605 0 0 0-12.16 0 .7.7 0 0 1-.991-.99 10.01 10.01 0 0 1 14.141 0 .7.7 0 0 1-.495 1.194",
    transform: "translate(7.276 7)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Pfad 2744",
    d: "M5 7v4l2-2V7zM0 2l5 4h2l5-4zm0-1h12V0H0z",
    transform: "translate(13 18)",
    style: {
      fill: "#f5f5f5"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaterFilterSensor);
export default __webpack_public_path__ + "static/media/water-filter-sensor.9f8a48f60e40be069f468f9bf5b4c107.svg";
export { ForwardRef as ReactComponent };